<template>
  <div class="panel">
    <div class="content">
      <div class="title">{{ $t(`resume.sections.${resume.language || 'fr'}.contact`) }}</div>
      <div class="divider" />
      <div class="check">
        <input id="hideItem" v-model="hideItem" type="checkbox" />
        <label for="hideItem">{{ $t('editor.contact.hide') }}</label>
      </div>
      <div class="divider" />
      <div class="section">
        <div class="items">
          <div class="item">
            <div class="text">{{ $t('editor.contact.companyName') }}</div>
            <FireInput
              ref="companyName-field"
              class="text-input"
              :auto-focus="true"
              :value="resume.contact.companyName"
              @change="value => valueChanged(value, 'companyName')"
            />
          </div>
          <div class="item">
            <div class="text">{{ $t('editor.contact.address') }}</div>
            <FireArea
              ref="address-field"
              :auto-focus="true"
              :value="resume.contact.address"
              :template-div-container="'address'"
              @change="value => valueChanged(value, 'address')"
            />
          </div>
          <div class="item">
            <div class="text">{{ $t('editor.contact.firstname') }}</div>
            <FireInput
              ref="firstname-field"
              class="text-input"
              :auto-focus="true"
              :value="resume.contact.firstname"
              @change="value => valueChanged(value, 'firstname')"
            />
          </div>
          <div class="item">
            <div class="text">{{ $t('editor.contact.lastname') }}</div>
            <FireInput
              ref="lastname-field"
              class="text-input"
              :auto-focus="true"
              :value="resume.contact.lastname"
              @change="value => valueChanged(value, 'lastname')"
            />
          </div>
          <div class="item">
            <div class="text">{{ $t('editor.contact.phone') }}</div>
            <FireInput
              ref="phoneNumber-field"
              class="text-input"
              :auto-focus="true"
              :value="resume.contact.phoneNumber"
              @change="value => valueChanged(value, 'phoneNumber')"
            />
          </div>
          <div class="item nopadding">
            <div class="text">{{ $t('editor.contact.email') }}</div>
            <FireInput
              ref="email-field"
              class="text-input"
              :auto-focus="true"
              :value="resume.contact.email"
              @change="value => valueChanged(value, 'email')"
            />
          </div>
        </div>
        <div class="divider" />
        <div v-if="loggedIn" class="secondary-button" @click.stop="replaceAllInfo">
          <ReplaceIcon class="icon" />
          {{ $t('editor.contact.replceWithPersonal') }}
        </div>
      </div>
    </div>
    <div ref="resize-handle" class="resize">
      <div class="line" />
      <div class="line" />
      <div class="line" />
    </div>
  </div>
</template>

<script>
import FireArea from '@/components/inputs/FireArea';
import FireInput from '@/components/inputs/FireInput';
import ReplaceIcon from '@/assets/listing/arrow_replace.svg';

import PanelMixin from './mixins/PanelMixin';
import { mapGetters } from 'vuex';
export default {
  name: 'ContactPanel',
  components: {
    FireArea,
    FireInput,
    ReplaceIcon,
  },
  mixins: [PanelMixin],
  props: {
    resume: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      hideItem: false,
      sectionId: 'contact',
    };
  },
  computed: {
    ...mapGetters(['user', 'loggedIn']),
  },
  watch: {
    hideItem(value) {
      this.valueChanged(value, 'isHidden');
    },
  },
  created() {
    this.hideItem = this.resume.contact.isHidden;
  },
  methods: {
    async replaceAllInfo() {
      const contact = {
        firstname: this.user.firstName,
        lastname: this.user.lastName,
        address: this.user.address,
        email: this.user.email,
        phoneNumber: this.user.phoneNumber || '',
        companyName: this.user.organization ? this.user.organization.name : '',
        isHidden: false,
      };
      this.$refs['firstname-field'].updateInput(this.user.firstName);
      this.$refs['lastname-field'].updateInput(this.user.lastName);
      this.$refs['address-field'].updateInput(this.user.address);
      this.$refs['email-field'].updateInput(this.user.email);
      this.$refs['phoneNumber-field'].updateInput(this.user.phoneNumber);
      this.$refs['companyName-field'].updateInput(this.user.organization ? this.user.organization.name : '');
      this.isHidden = false;

      await this.$store.dispatch('resume.contact.edit', {
        contactId: this.resume.contact.id,
        data: contact,
      });
    },
    valueChanged(value, key) {
      const content = {};
      content[key] = value;
      this.$store.dispatch('resume.contact.edit', {
        contactId: this.resume.contact.id,
        data: content,
      });
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/inspector.scss';
@use '@/styles/utils.scss';

.check {
  display: flex;
  align-items: center;
  label {
    margin-left: 4px;
    user-select: none;
    display: block;
    @extend .uppercase-first;
    color: colors.$dark-grey-color;
    cursor: pointer;
  }
}
.icon {
  color: white !important;
}
</style>
